(() => {
  if (window.__vantageJournalTracking) return;
  window.__vantageJournalTracking = true;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-journal-link]');
    if (!link || !(link instanceof HTMLAnchorElement)) return;

    const destination = new URL(link.href, window.location.origin);
    const payload = {
      source_path: window.location.pathname,
      destination_path: destination.pathname,
      link_type: link.dataset.linkType || 'other',
      link_text: (link.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 120),
      viewport: window.innerWidth < 750 ? 'mobile' : 'desktop',
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'journal_link_clicked', ...payload });

    try {
      const publishResult = window.Shopify?.analytics?.publish?.(
        'vantage_goods:journal_link_clicked',
        payload
      );
      publishResult?.catch?.(() => {});
    } catch {}

    try {
      window.posthog?.capture?.('journal_link_clicked', payload);
    } catch {}
  });
})();
